import head from 'lodash/head';
import find from 'lodash/find';

export class GoogleLocationService {

    _formatAddress(details) {
        let locality = '';
        let addressDetails = {};
        let adressLine1 = [];
        details.address_components.map((data) => {
            let type = head(data.types);
            
            if(type === 'locality') {
                locality = data.long_name;
            }
        
            switch(type) {
                case 'street_number':
                case 'neighborhood':
                case 'route':
                case 'sublocality_level_2':
                case 'sublocality':
                case 'premise':
                case 'locality':
                    adressLine1.push(data.long_name);
                break;
                case 'administrative_area_level_2':
                    addressDetails.cityName = data.long_name;
                break;
                case 'administrative_area_level_1':
                    addressDetails.stateName = data.long_name;
                    addressDetails.stateCode = data.short_name;
                break;
                case 'postal_code':
                    addressDetails.zipcode = data.long_name;
                break;
            }
        });

        addressDetails.cityName = (!addressDetails.cityName) ? locality : addressDetails.cityName; 
        addressDetails.addressLine1 = adressLine1.length > 0 ? adressLine1.join(' ') : '';
        addressDetails.lat = details.geometry.location.lat();
        addressDetails.lng = details.geometry.location.lng();
        return addressDetails;
    }
};


// WEBPACK FOOTER //
// ./src/app/common/components/google-location/google-location.service.js